import {useMemo} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import messages from "./messages";
import {Grid, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {withRouter} from "react-router";
import Base from "components/Message/Base";

const useStyles = makeStyles(theme => ({
  poDetails: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "& > *:nth-child(2)": {
      paddingLeft: theme.spacing(2),
    },

    "&.latest": {
      borderBottom: "none",
      paddingBottom: theme.spacing(0),
    },
  },
  messageBox: {
    border: "1px solid rgba(0,0,0,0.24)",
    borderColor: "rgba(0,0,0,0.24)",
  },
}));

function PlanMessage({
  activeMessage = {},
  onClose,
  onCloseMessage,
  title,
  upperProductName,
  lowerProductName,
  showPatient,
  caseId
}) {
  const classes = useStyles({});

  const body = useMemo(
    () => (
      <div className={classes.body} data-cy="bodyMessage">
        <Grid container className={classes.poDetails}>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="caption"
            >
              <FormattedMessage {...messages.planned_treatment_case_nr} />
            </Typography>
            <Typography
              variant="subtitle1"
            >
              {caseId}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
          </Grid>
        </Grid>
        <Grid container className={classes.poDetails}>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="caption"
            >
              <FormattedMessage {...messages.order_placed_upper_product} />
            </Typography>
            <Typography
              variant="subtitle1"
            >
              {upperProductName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="caption"
            >
              <FormattedMessage {...messages.order_placed_lower_product} />
            </Typography>
            <Typography
              variant="subtitle1"
            >
              {lowerProductName}
            </Typography>
          </Grid>
        </Grid>
      </div>
    ),
    [
      classes.body,
      classes.poDetails,
      onCloseMessage
    ],
  );

  return (
    <>
      <Base
        key="message"
        className={classes.messageBox}
        onClose={onClose}
        shouldRenderPatient={showPatient}
        title={title}
        activeMessage={activeMessage}
      >
        {body}
      </Base>
    </>
  );
}

PlanMessage.propTypes = {
  activeMessage: PropTypes.shape({
    updatedAt: PropTypes.number,
    changesList: PropTypes.array,
    productOrder: PropTypes.shape({
      lowerProductName: PropTypes.string,
      upperProductName: PropTypes.string,
      phase: PropTypes.string,
      avadentCaseId: PropTypes.string,
      refittingPossible: PropTypes.bool,
      nextOrderPossible: PropTypes.bool
    }),
    patient: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  onClose: PropTypes.func.isRequired,
  onCloseMessage: PropTypes.func,
  title: PropTypes.string,
  upperProductName: PropTypes.string,
  lowerProductName: PropTypes.string,
};

export default withRouter(PlanMessage);
